import { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Form } from 'forms/rrf';
import { Col, Row } from 'react-bootstrap';
import RequiredInput from '../../../common/form/elements/required-input';
import ArrowButton from '../../../common/button-arrow';
import { getSettings, saveSettings } from '../../../../actions/staff';

class SettingsForm extends Component {
  state = {
    value: ''
  };

  onSubmit = (payLoad) => {
    this.props.dispatch(actions.submitFields('deep.admin_settings', saveSettings(payLoad)));
  };

  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getSettings());
  }

  render() {
    return (
      <Form model="deep.admin_settings" onSubmit={this.onSubmit}>
        <Row>
          <Col lg={12}>
            <RequiredInput
              controlId="game_expiry_days"
              label="Game Expiry Days"
              type="number"
              model=".game_expiry_days"
              placeholder="e.g. 2"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredInput
              type="number"
              label="Scan Override Threshold"
              controlId="scan_override_threshold"
              model=".scan_override_threshold"
              placeholder="e.g. 100"
              positive
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredInput
              type="number"
              label="Achievement Target"
              controlId="achievement_target"
              model=".achievement_target"
              placeholder="e.g. 10"
              positive
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredInput
              type="number"
              label="Scan Target"
              controlId="scan_target"
              model=".scan_target"
              placeholder="e.g. 2"
              positive
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredInput
              type="number"
              label="Overarching Threshold"
              controlId="overarching_threshold"
              model=".overarching_threshold"
              placeholder="e.g. 20"
              positive
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrowButton
              className="float-end"
              color="grey"
              disabled={!this.props.formValid}
            >
              Save
            </ArrowButton>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.admin_settings.$form.valid,
  postcodeplanRedemptionDate: state.deep.admin_settings.postcodeplan_redemption_date,
});

export default connect(mapStateToProps)(SettingsForm);
